import { render, staticRenderFns } from "./InviteParticipants.vue?vue&type=template&id=6f4c886a&scoped=true&"
import script from "./InviteParticipants.vue?vue&type=script&lang=js&"
export * from "./InviteParticipants.vue?vue&type=script&lang=js&"
import style0 from "./InviteParticipants.vue?vue&type=style&index=0&id=6f4c886a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c886a",
  null
  
)

export default component.exports